import React, { PropTypes } from 'react';
import { Link } from 'react-router'
import CurrentRoleStore from '../stores/CurrentRoleStore';
import NotificationCountStore from '../stores/NotificationCountStore';
import DataService from '../lib/DataService';
import SharedTools from '../lib/SharedTools';
import GlobalSharedTools from '../../../lib/GlobalSharedTools';

const USER_ROLE_TYPES = {
  SYSTEM:'system_admin',
  TEACHER: 'teacher',
  GRADE_ADMIN: 'grade_admin',
  SCHOOL_ADMIN: 'school_admin',
  PARENT: 'parent'
}

export default class NavigationSideBar extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      albumLink: "",
      recordLink: "",
      url: window.location.href,
      unreadCount: 0,
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.onNotificationCountChange = this.onNotificationCountChange.bind(this);

    this.isInClassAlbumSection = this.isInClassAlbumSection.bind(this);
    this.isInStudentRecordSection = this.isInStudentRecordSection.bind(this);
    this.isInClassNotificationSection = this.isInClassNotificationSection.bind(this);
    this.isInTeacherManagementSection = this.isInTeacherManagementSection.bind(this);
    this.isInClassManagementSection = this.isInClassManagementSection.bind(this);
    this.isInArchiveContentSettingSection = this.isInArchiveContentSettingSection.bind(this);
    this.isInArchiveProcessSection = this.isInArchiveProcessSection.bind(this);
    this.isInArchiveRecordEditSection = this.isInArchiveRecordEditSection.bind(this);

    this.isInArchiveBookSection = this.isInArchiveBookSection.bind(this);

    this.isUserRoleIn = this.isUserRoleIn.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      url: window.location.href,
    })
  }

  componentDidMount(){
      CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
      NotificationCountStore.addChangeListener(this.onNotificationCountChange);
      let roleName = this.state.currentRole.associatName;
      let role = this.state.currentRole;
      if(roleName == 'student'){
        this.setState({
          albumLink: "albums/index",
          recordLink: `record/students/${role.associatObj.id}`,
        })
      }else if(roleName == 'classRecord'){
        this.setState({
          albumLink: "albums/index",
          recordLink: `record/index?classId=${role.associatObj.id}`,
        })
      }
      else if(roleName == 'classGrade'){
        this.setState({
          albumLink: "albums/manage",
          recordLink: "record/manage",
        })
      }
      else if(roleName == 'school'||roleName =='system'){
        this.setState({
          albumLink: "albums/manage",
          recordLink: "record/manage",
        })
      }

      this.onNotificationCountChange();
      if(roleName!=='system'||(roleName==='system'&&role.associatObj&&role.associatObj.schoolId))
        this.getSchoolSetting(roleName == 'school' ? role.associatObj.id : role.associatObj.schoolId);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
    NotificationCountStore.removeChangeListener(this.onNotificationCountChange);
  }

  onCurrentRoleChange() {
    let newRole = CurrentRoleStore.getCurrentRole()
    let role = newRole
    if(role.associatObj&&role.associatObj.id)
      this.getSchoolSetting(role.associatName == 'school' ? role.associatObj.id : role.associatObj.schoolId);
    this.setState({
      currentRole: newRole
    });
  }

  onNotificationCountChange() {
    if (this.state.currentRole && this.state.currentRole.associatName == "student") {
      DataService.getUnreadNotificationsCount(this.state.currentRole.associatObj.id, this.state.currentRole.associatObj.classId).then(response => {
        this.setState({
          unreadCount: response.unread_count
        })
      })
    }
  }

  getSchoolSetting(schoolId) {
    DataService.getSchoolSetting(schoolId).then(response => {
      this.setState({
        showAlbum: response.album_menu.findIndex((item) => item == '相册') >= 0 ? true : false,
        showArchive: response.album_menu.findIndex((item) => item == '成长档案') >= 0 ? true : false,
        showTask: response.album_menu.findIndex((item) => item == '打卡') >= 0 ? true : false,
        showNotification: response.album_menu.findIndex((item) => item == '通知') >= 0 ? true : false,

        showAttendance: response.album_menu.findIndex((item) => item == '考勤') >= 0 ? true : false,

        showStudentRecognition: (response.gate_setting && response.gate_setting.student) ? (response.gate_setting.student.length > 0 ? true : false) : false, //是否隐藏侧边栏门禁识别
        showTeacherRecognition: (response.gate_setting && response.gate_setting.teacher) ? (response.gate_setting.teacher.length > 0 ? true : false) : false,

        showStudentAttendance: (response.gate_setting && response.gate_setting.student_clock_on) ? response.gate_setting.student_clock_on : false,
        showTeacherAttendance: (response.gate_setting && response.gate_setting.teacher_clock_on) ? response.gate_setting.teacher_clock_on : false,

        showDevelopment: response.album_menu.findIndex((item) => item == '发展') >= 0 ? true : false,
      })
    })
  }

  // 侧边栏显示判断
  isInClassAlbumSection() {
    return this.state.url.indexOf('albums') >= 0;
  }
  isInSystemAdminSchoolSearch(){
    return this.state.url.indexOf('system-admin/school-search') >= 0;
  }
  isInSystemAdminUserSearch(){
    return this.state.url.indexOf('system-admin/user-search') >= 0;
  }
  isInSystemAdminStudentSearch(){
    return this.state.url.indexOf('system-admin/student-search') >= 0;
  }
  isInSystemAdminSetPublicAccount(type){
    return this.state.url.indexOf(`system-admin/set-public-account/${type}`) >= 0;
  }
  isInSystemAdminPdfTask(task){
    return this.state.url.indexOf(`system-admin/pdf-task/${task}`) >= 0;
  }
  isInSystemAdminUploadReview(){
    return this.state.url.indexOf('system-admin/upload-review') >= 0;
  }

  isInStudentRecordSection() {
    return this.state.url.indexOf('record') >= 0 && this.state.url.indexOf('archive') < 0 && this.state.url.indexOf('student-attendance') < 0 && this.state.url.indexOf('teacher-attendance') < 0 && this.state.url.indexOf('development') < 0;
  }

  isInAttendanceSection() {
    return this.state.url.indexOf('clock-in') >= 0;
  }

  isInClassNotificationSection() {
    return this.state.url.indexOf('notifications') >= 0;
  }

  isInTeacherManagementSection() {
    return (this.state.url.indexOf('school-admin/schools') >= 0) && (this.state.url.indexOf('teacher-management') >= 0);
  }

  isInClassManagementSection() {
    return (this.state.url.indexOf('school-admin/schools') >= 0) && (this.state.url.indexOf('class-management') >= 0);
  }

  isInArchiveBookSection() {
    return (this.state.url.indexOf('archive/book') >= 0);
  }

  isInArchiveReviewSection() {
    return this.state.url.indexOf('archive/review') >= 0;
  }

  isInArchiveContentSettingSection() {
    return this.state.url.indexOf('archive/content-setting') >= 0;
  }

  isInArchiveProcessSection() {
    return this.state.url.indexOf('archive/archive-process') >= 0;
  }

  isInArchiveRecordEditSection() {
    return (this.state.url.indexOf('archive/record') >= 0);
  }

  // 考勤
  isInAttendanceRercord(role) {
    return (this.state.url.indexOf('attendance-record') >= 0 && this.state.url.indexOf(`${role}-attendance`) >= 0);
  }

  isInAttendanceStatistics(role) {
    return (this.state.url.indexOf('attendance-statistics') >= 0 && this.state.url.indexOf(`${role}-attendance`) >= 0);
  }

  isInAttendanceRecognition(role) {
    return (this.state.url.indexOf('attendance-recognition') >= 0 && this.state.url.indexOf(`${role}-attendance`) >= 0);
  }

  isInAttendanceCalendar(role) {
    return (this.state.url.indexOf('attendance-calendar') >= 0 && this.state.url.indexOf(`${role}-attendance`) >= 0);
  }

  isInTeacherAttendanceDetail() {
    return this.state.url.indexOf('attendance-detail') >= 0;
  }

  isRegisterationReportSection() {
    return (this.state.url.indexOf('school-admin/schools') >= 0) && (this.state.url.indexOf('registeration-management') >= 0);
  }

  isUsageReportSection() {
    return (this.state.url.indexOf('school-admin/schools') >= 0) && (this.state.url.indexOf('usage-report') >= 0);
  }

  // 发展评价
  isInObservationRecordPage() {
    return this.state.url.indexOf('development/observation-record') >= 0;
  }

  isInEvaluateRecordPage() {
    return this.state.url.indexOf('development/evaluation-record') >= 0;
  }

  isInClassEvaluateRecordPage() {
    return this.state.url.indexOf('development/class-evaluation') >= 0;
  }

  isInDevelopmentReportPage() {
    return this.state.url.indexOf('development/report') >= 0;
  }

  toolReportUrl() {
    if (this.state.currentRole && this.state.currentRole.associatName == 'classRecord') {
      return `school-admin/schools/${this.state.currentRole.associatObj.schoolId}/usage-report/classes/${this.state.currentRole.associatObj.id}`
    } else if (this.state.currentRole.associatName == 'classGrade') {
      return `school-admin/schools/${this.state.currentRole.associatObj.schoolId}/usage-report`
    } else {
      return `school-admin/schools/${this.state.currentRole.associatObj.id}/usage-report`
    }
  }

  // check is current user role is one of some specify role types
  // @roles: array of USER_ROLE_TYPES elements
  isUserRoleIn(roleTypes) {
    let result = false;
    if (this.state.currentRole && roleTypes.length > 0) {
      for (let roleTypeIndex in roleTypes) {
        let roleType = roleTypes[roleTypeIndex];
        switch (roleType) {
          case USER_ROLE_TYPES.SYSTEM:
            if (this.state.currentRole.associatName == "system")
              result = true;
            break;
          case USER_ROLE_TYPES.TEACHER:
            if (this.state.currentRole.associatName == "classRecord")
              result = true;
            break;
          case USER_ROLE_TYPES.GRADE_ADMIN:
            if (this.state.currentRole.associatName == "classGrade")
              result = true;
            break;
          case USER_ROLE_TYPES.SCHOOL_ADMIN:
            if (this.state.currentRole.associatName == "school" ||(this.state.currentRole.associatName == "system"&&this.state.currentRole.associatObj&&this.state.currentRole.associatObj.searched))
              result = true;
            break;
          case USER_ROLE_TYPES.PARENT:
            if (this.state.currentRole.associatName == "student")
              result = true;
            break;
        }
        if (result)
          break;
      }
    }
    return result;
  }

  render() {
    return (
      <div className="navigation-side-bar">
        {this.state.showAlbum && this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER, USER_ROLE_TYPES.PARENT])&& <div>
          <div className="section-title">班级相册</div>
          <Link className={"link" + (this.isInClassAlbumSection() ? ' active' : '')} activeClassName="active" to={this.state.albumLink} >
            <span className="icon album"></span>
            <span className="name">班级相册</span>
          </Link>
          <Link className={"link" + (this.isInStudentRecordSection() ? ' active' : '')} activeClassName="active" to={this.state.recordLink} >
            <span className="icon record"></span>
            <span className="name">宝贝相册</span>
          </Link>
        </div> }

        <div className="seperator"></div>
        {this.state.showTask && this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) &&
          <Link className={"link" + (this.isInAttendanceSection() ? ' active' : '')} activeClassName="active" to={"clock-in"} >
            <span className="icon clock"></span>
            <span className="name">打卡</span>
          </Link>
        }
        {this.state.showNotification&& this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER, USER_ROLE_TYPES.PARENT])&& <Link className={"link" + (this.isInClassNotificationSection() ? ' active' : '')} activeClassName="active" to={"notifications"} >
          <span className="icon notification"></span>
          <span className="name">班级通知</span>
          {this.state.unreadCount > 0 && <span className="unread-notifications">{this.state.unreadCount > 99 ? "99" : this.state.unreadCount}</span>}
        </Link> }
        <Link className="link" activeClassName="active" to={"fake-addr"} style={{display: 'none'}} >
          <span className="icon news"></span>
          <span className="name">班级新闻</span>
        </Link>


        {this.state.showArchive && this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER, USER_ROLE_TYPES.PARENT])&& <div>
          <div className="section-title">成长档案</div>
          {/* {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInArchiveReviewSection() ? ' active' : '')} activeClassName="active" to={`archive/review/schools/${this.state.currentRole.associatName == "classGrade" ? this.state.currentRole.associatObj.schoolId : this.state.currentRole.associatObj.id}`} >
              <span className="icon archive-review"></span>
              <span className="name">档案审核</span>
            </Link>
          } */}
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInArchiveBookSection() ? ' active' : '')} activeClassName="active" to={"archive/book"} >
              <span className="icon archive-view"></span>
              <span className="name">档案查看</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInArchiveContentSettingSection() ? ' active' : '')} activeClassName="active" to={`archive/content-setting/schools/${this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}`} >
              <span className="icon content-setting"></span>
              <span className="name">档案内容设置</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInArchiveProcessSection() ? ' active' : '')} activeClassName="active" to={`archive/archive-process/schools/${this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}`} >
              <span className="icon archive-process"></span>
              <span className="name">档案完成进度</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.PARENT, USER_ROLE_TYPES.TEACHER]) &&
            <Link className={"link" + (this.isInArchiveRecordEditSection() ? ' active' : '')} activeClassName="active" to={`archive/record/index`}>
              <span className="icon growth"></span>
              <span className="name">成长记录</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.PARENT, USER_ROLE_TYPES.TEACHER]) &&
            <Link className={"link" + (this.isInArchiveBookSection() ? ' active' : '')} activeClassName="active" to={this.isUserRoleIn([USER_ROLE_TYPES.PARENT]) ? `archive/book/classes/${this.state.currentRole.associatObj.classId}/students/${this.state.currentRole.associatObj.id}?studentName=${this.state.currentRole.associatObj.fullName}&semester=${SharedTools.getCurrentSemester()}` : `archive/book/classes/${this.state.currentRole.associatObj.id}?semester=${SharedTools.getCurrentSemester()}`} >
              <span className="icon archive-view"></span>
              <span className="name">成长档案</span>
            </Link>
          }
          <Link className="link" activeClassName="active" to={"fake-addr"} style={{display: 'none'}} >
            <span className="icon record"></span>
            <span className="name">成长记录册</span>
          </Link>
        </div> }

        {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) && this.state.showDevelopment && <div>
          <div className="section-title">发展评价</div>
          <Link className={"link" + (this.isInObservationRecordPage() ? ' active' : '')} activeClassName="active" to={this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) ? `development/observation-record` : `development/observation-record/classes/${this.state.currentRole.associatObj.id}`}>
            <span className="icon development"></span>
            <span className="name">观察记录</span>
          </Link>
          <Link className={"link" + (this.isInEvaluateRecordPage() ? ' active' : '')} activeClassName="active" to={this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) ? `development/evaluation-record` : `development/evaluation-record/classes/${this.state.currentRole.associatObj.id}`}>
            <span className="icon development"></span>
            <span className="name">个体评价</span>
          </Link>
          <Link className={"link" + (this.isInClassEvaluateRecordPage() ? ' active' : '')} activeClassName="active" to={this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) ? `development/class-evaluation` : `development/class-evaluation/classes/${this.state.currentRole.associatObj.id}`}>
            <span className="icon development"></span>
            <span className="name">班级评价</span>
          </Link>
          <Link className={"link" + (this.isInDevelopmentReportPage() ? ' active' : '')} activeClassName="active" to={this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) ? `development/report` : `development/report/classes/${this.state.currentRole.associatObj.id}?className=${this.state.currentRole.associatObj.className}&gradeId=${this.state.currentRole.associatObj.gradeId}`}>
            <span className="icon development"></span>
            <span className="name">发展报告</span>
          </Link>
        </div>}

        {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) && this.state.showAttendance && this.state.showStudentAttendance && <div>
          <div className="section-title">学生考勤</div>
          <Link className={"link" + (this.isInAttendanceRercord('student') ? ' active' : '')} activeClassName="active" to={`student-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-record`} >
            <span className="icon attendance-record"></span>
            <span className="name">学生考勤日报</span>
          </Link>
          <Link className={"link" + (this.isInAttendanceStatistics('student') ? ' active' : '')} activeClassName="active" to={`student-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-statistics`} >
            <span className="icon attendance-statistics"></span>
            <span className="name">学生考勤月报</span>
          </Link>
          {this.state.showStudentRecognition ? <Link className={"link" + (this.isInAttendanceRecognition('student') ? ' active' : '')} activeClassName="active" to={`student-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-recognition`} >
            <span className="icon attendance-recognition"></span>
            <span className="name">学生门禁识别</span>
          </Link> : ''}
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) && 
            <Link className={"link" + (this.isInAttendanceCalendar('student') ? ' active' : '')} activeClassName="active" to={`student-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-calendar`} >
              <span className="icon attendance-calendar"></span>
              <span className="name">学生考勤校历</span>
            </Link>
          }
        </div>}

        {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) && this.state.showAttendance && this.state.showTeacherAttendance && <div>
          <div className="section-title">老师考勤</div>
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInAttendanceRercord('teacher') ? ' active' : '')} activeClassName="active" to={`teacher-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-record`} >
              <span className="icon attendance-record"></span>
              <span className="name">老师考勤日报</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) &&
            <Link className={"link" + (this.isInAttendanceStatistics('teacher') ? ' active' : '')} activeClassName="active" to={`teacher-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-statistics`} >
            <span className="icon attendance-statistics"></span>
              <span className="name">老师考勤月报</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) && this.state.showTeacherRecognition &&
            <Link className={"link" + (this.isInAttendanceRecognition('teacher') ? ' active' : '')} activeClassName="active" to={`teacher-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-recognition`} >
              <span className="icon attendance-recognition"></span>
              <span className="name">老师门禁识别</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN]) &&
            <Link className={"link" + (this.isInAttendanceCalendar('teacher') ? ' active' : '')} activeClassName="active" to={`teacher-attendance/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/attendance-calendar`} >
            <span className="icon attendance-calendar"></span>
              <span className="name">老师考勤校历</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.TEACHER]) &&
            <Link className={"link" + (this.isInTeacherAttendanceDetail() ? ' active' : '')} activeClassName="active" to={`teacher-attendance/attendance-detail`} >
              <span className="icon attendance-record"></span>
              <span className="name">我的考勤情况</span>
            </Link>
          }
          
        </div>}

        {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) && <div>
          <div className="section-title">学校管理</div>
          <Link className={"link" + (this.isInClassManagementSection() ? ' active' : '')} activeClassName="active" to={`school-admin/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/class-management`} >
            <span className="icon manage"></span>
            <span className="name">班级管理</span>
          </Link>
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN]) &&
            <Link className={"link" + (this.isInTeacherManagementSection() ? ' active' : '')} activeClassName="active" to={`school-admin/schools/${this.state.currentRole ? this.state.currentRole.associatObj.id : 0}/teacher-management`} >
              <span className="icon manage"></span>
              <span className="name">老师管理</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN]) &&
            <Link className="link" activeClassName="active" to={"fake-addr"} style={{display: 'none'}} >
              <span className="icon archive-content"></span>
              <span className="name">学校信息管理</span>
            </Link>
          }
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN, USER_ROLE_TYPES.TEACHER]) && <div>
          <div className="section-title">报告</div>
          {this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN, USER_ROLE_TYPES.GRADE_ADMIN]) && 
            <Link className={"link" + (this.isRegisterationReportSection() ? ' active' : '')} activeClassName="active" to={`school-admin/schools/${(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/registeration-report`} >
              <span className="icon manage"></span>
              <span className="name">注册报告</span>
            </Link>
          }
            <Link className={"link" + (this.isUsageReportSection() ? ' active' : '')} activeClassName="active" to={this.toolReportUrl()} >
            <span className="icon manage"></span>
            <span className="name">使用报告</span>
          </Link>
        </div>}
        </div>}
        {this.isUserRoleIn([USER_ROLE_TYPES.SYSTEM]) &&!this.isUserRoleIn([USER_ROLE_TYPES.SCHOOL_ADMIN])&&
          <div>
            <div>
              <div className="section-title">学校管理</div>
              <Link className={"link" + (this.isInSystemAdminSchoolSearch() ? ' active' : '')} activeClassName="active" to={`system-admin/school-search`}>
                <span className="icon development"></span>
                <span className="name">搜索学校</span>
              </Link>
            </div>
            <div>
              <div className="section-title">用户管理</div>
              <Link className={"link" + (this.isInSystemAdminUserSearch() ? ' active' : '')} activeClassName="active" to={`system-admin/user-search`}>
                <span className="icon development"></span>
                <span className="name">搜索用户</span>
              </Link>
            </div>
            <div>
              <div className="section-title">学生管理</div>
              <Link className={"link" + (this.isInSystemAdminStudentSearch() ? ' active' : '')} activeClassName="active" to={`system-admin/student-search`}>
                <span className="icon development"></span>
                <span className="name">搜索学生</span>
              </Link>
            </div>
            <div>
              <div className="section-title">公众号设置</div>
              <Link className={"link" + (this.isInSystemAdminSetPublicAccount(false) ? ' active' : '')} activeClassName="active" to={`system-admin/set-public-account/0`}>
                <span className="icon development"></span>
                <span className="name">当前自动回复列表</span>
              </Link>
              <Link className={"link" + (this.isInSystemAdminSetPublicAccount(true) ? ' active' : '')} activeClassName="active" to={`system-admin/set-public-account/1`}>
                <span className="icon development"></span>
                <span className="name">新增自动回复列表</span>
              </Link>
            </div>
            <div>
              <div className="section-title">PDF任务管理</div>
              <Link className={"link" + (this.isInSystemAdminPdfTask(0) ? ' active' : '')} activeClassName="active" to={`system-admin/pdf-task/0`}>
                <span className="icon development"></span>
                <span className="name">当前任务列表</span>
              </Link>
              <Link className={"link" + (this.isInSystemAdminPdfTask(1) ? ' active' : '')} activeClassName="active" to={`system-admin/pdf-task/1`}>
                <span className="icon development"></span>
                <span className="name">新建生成任务</span>
              </Link>
            </div>
            <div>
              <div className="section-title">主题评价管理</div>
              <Link className={"link" + (this.isInSystemAdminUploadReview() ? ' active' : '')} activeClassName="active" to={`system-admin/upload-review`}>
                <span className="icon development"></span>
                <span className="name">上传主题评价</span>
              </Link>
            </div>
          </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/NavigationSideBar.jsx